import { useNavigate } from 'react-router-dom';
import { styled } from '@tigergraph/app-ui-lib/Theme';
import { Button } from '@tigergraph/app-ui-lib/button';

import { useStyletron } from '@tigergraph/app-ui-lib/Theme';
import currency from 'currency.js';
import { formatPricePerHour } from '@/utils/format';
import { useQuery } from 'react-query';
import { getUserCreditsRep } from '@/pages/admin/bill/api';
import creditsIcon from '../icons/credits.svg';
import mediaQuery from '@/lib/breakpoints';
type Props = {
  computePrice: currency;
  storagePrice: currency;
  addOnPrice: currency;
  isLoading: boolean;
  cancelLabel?: string;
  confirmLabel: string;
};

const PriceCalculator = ({ computePrice, storagePrice, addOnPrice, isLoading, cancelLabel, confirmLabel }: Props) => {
  const [css, theme] = useStyletron();
  const navigate = useNavigate();

  let { data: userCredits } = useQuery('user-credits', getUserCreditsRep, { staleTime: 0 });

  return (
    <Container>
      <div
        className={css({
          fontSize: '16px',
          lineHeight: '24px',
          display: 'grid',
          gridTemplateColumns: 'auto 160px',
          marginRight: 'auto',
          [mediaQuery.small]: {
            gridColumn: '1 / -1',
            marginRight: 0,
          },
        })}
      >
        <div
          className={css({
            color: theme.colors['text.secondary'],
          })}
        >
          Compute
        </div>
        <div
          className={css({
            justifySelf: 'end',
          })}
        >
          {formatPricePerHour(computePrice)}
        </div>
        <div
          className={css({
            color: theme.colors['text.secondary'],
          })}
        >
          Add-Ons
        </div>
        <div
          className={css({
            justifySelf: 'end',
          })}
        >
          {formatPricePerHour(addOnPrice)}
        </div>
        <div
          className={css({
            color: theme.colors['text.secondary'],
          })}
        >
          Storage
        </div>
        <div
          className={css({
            justifySelf: 'end',
          })}
        >
          {storagePrice.format()}/GB/month
        </div>
      </div>
      <div>
        <div
          className={css({
            fontSize: '12px',
            lineHeight: '16px',
            marginBottom: '4px',
          })}
        >
          Hourly Rate From
        </div>
        <div
          className={css({
            fontSize: '32px',
            lineHeight: '40px',
            fontWeight: '600',
          })}
        >
          {formatPricePerHour(computePrice.add(addOnPrice))}
        </div>
        {userCredits && userCredits > 0 ? (
          <div
            className={css({
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
            })}
          >
            <span>Your Free Credits:</span>
            <img src={creditsIcon} alt="Credits" className={css({ marginLeft: '4px' })} />
            <span className={css({ color: theme.colors['text.success'], fontWeight: '700' })}>{`$${userCredits.toFixed(
              2
            )}`}</span>
          </div>
        ) : null}
      </div>
      <div
        className={css({
          display: 'flex',
          gap: '16px',
        })}
      >
        <Button disabled={isLoading} type="button" onClick={() => navigate(-1)} kind="secondary" size="large">
          {cancelLabel || 'Cancel'}
        </Button>
        <Button isLoading={isLoading} type="submit" size="large">
          {confirmLabel}
        </Button>
      </div>
    </Container>
  );
};

const Container = styled('section', ({ $theme }) => ({
  borderTop: `1px solid ${$theme.colors.divider}`,
  display: 'flex',
  alignItems: 'center',
  gap: '80px',
  padding: '16px 48px',
  backgroundColor: $theme.colors['background.alternative'],
  [mediaQuery.small]: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gap: '16px',
    padding: '24px 16px',
  },
}));

export default PriceCalculator;
